import {ChangeDetectorRef, Component, ElementRef} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {NavController, NavParams, Platform} from 'ionic-angular';

import {Location} from '../../models/location';
import {Data} from '../../providers/providers';
import {Thinning} from '../../providers/providers';
import {Speech} from '../../providers/providers';

import {ThinningMeasurement} from "../../models/thinning-measurement";

import {ThinningDataset} from "../../models/thinning-dataset";
import {AboutMeasurementDetailPage} from "../about-measurement-detail/about-measurement-detail";

@Component({
    selector: 'page-thinning-measurement-detail',
    templateUrl: 'thinning-measurement-detail.html'
})
export class ThinningMeasurementDetailPage {

    dataset: ThinningDataset;
    location: Location;
    measurement: ThinningMeasurement;
    previousMeasurement: ThinningMeasurement;
    form: FormGroup;
    currentCluster: number = 1; // current tab index

    constructor(public navCtrl: NavController,
                navParams: NavParams,
                public data: Data,
                public thinning: Thinning,
                public speech: Speech,
                public cd: ChangeDetectorRef) {
        this.dataset = navParams.get('dataset');
        this.location = navParams.get('location');
        this.measurement = navParams.get('measurement');

        // TODO: make sure this always works (thinning.setDataset needs to have been called)...
        this.previousMeasurement = thinning.getPreviousMeasurement(this.measurement);

        if (!this.measurement.data) { // can happen if all clusters were cleared
            this.measurement.data = {};
        }

        this.speech.setMeasurements(this.measurement,
            this.previousMeasurement,
            this.dataset.cluster_count,
            this.dataset.flower_count,
            this);
    }

    openAbout() {
        this.navCtrl.push(AboutMeasurementDetailPage, {});
    }

    refreshCalculations() {
        this.thinning.refreshThinningMeasurementSummary(this.measurement);
    }

    clearCluster(t, c) {
        if (confirm('Clear measurements for this cluster?')) {
            for (let f = 1; f <= this.dataset.flower_count; f++) {
                this.measurement.data[`${t}_${c}_${f}`] = null;
            }
            this.autosave();
        }
    }

    getClusterMeasurementCount(t, c) {
        var hasOnlyAZero = this.thinning.hasOnlyAZeroValue(this.measurement, t, c);
        var ct = this.thinning.getNonZeroValueCount(this.measurement, t, c);
        if (hasOnlyAZero) {
            return '(x)';
        } else if (ct) {
            return `(${ct})`
        } else {
            return '';
        }
    }

    autosave() {
        console.log('measurement autosave', this.measurement);
        this.data.updateThinningMeasurement(this.dataset, this.measurement);
        this.cd.detectChanges(); // refresh UI
    }
}




// WEBPACK FOOTER //
// ./src/pages/thinning-measurement-detail/thinning-measurement-detail.ts